import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;

  &>div {
    flex: 1 100%;
  }
`;
